import React from 'react'
import { Button, GlassMorphIcon } from '@/components/ui'
import { messages } from './messages'
import type { IPublicationFinancingWidgetCollapsingProps } from './types'
import './styles.scss'

export const PublicationFinancingWidgetSuccessOrder: React.FC<IPublicationFinancingWidgetCollapsingProps> = props => {
  const { onToOrder, onCloseSuccessMessage } = props

  return (
    <div className="publicationFinancingWidgetSuccessOrder">
      <GlassMorphIcon image="success" className="publicationFinancingWidgetSuccessOrder__icon" />
      <h3>{messages.title}</h3>
      <div className="publicationFinancingWidgetSuccessOrder__description">{messages.description}</div>

      <div className="publicationFinancingWidgetSuccessOrder__actions">
        <Button modifiers={['outline-gray', 'full-width-mobile']} onClick={onCloseSuccessMessage}>
          {messages.actions.close}
        </Button>
        <Button modifiers={['green', 'full-width-mobile']} onClick={onToOrder}>
          {messages.actions.toOrder}
        </Button>
      </div>
    </div>
  )
}
